// ----------------------------------------------------------------------------
// Geolocation (GeoJS)
// ----------------------------------------------------------------------------

var GEO_COUNTRY_URL = 'https://get.geojs.io/v1/ip/country.json';
var GEO_ROUTING_RULES_ELEMENT_ID = 'geo-routing-rules';
var callbacks = [];
var resolved = false;
var location = null;
var error = null;
var inflight = null;

/**
 * @typedef {object} GeolocationCountryRule
 * @property {string} country_code
 * @property {string} host
 * @property {string} [country]
 * @property {string} [demonym]
 * @property {string | null} [flag] CDN URL for metaobject flag image, when set
 */

/**
 * @typedef {object} GeoLocationPayload
 * @property {object | null} geo GeoJS response
 * @property {Error | null} error Fetch / parse failure
 * @property {string | null} countryCode ISO 3166-1 alpha-2 from GeoJS when `geo` is ok
 * @property {GeolocationCountryRule | null} countryRule Matched `#geo-routing-rules` row, if any
 */

function rulesFromDocument() {
  if (typeof document === 'undefined') {
    return [];
  }
  var el = document.getElementById(GEO_ROUTING_RULES_ELEMENT_ID);
  if (!el) {
    return [];
  }
  try {
    var parsed = JSON.parse(el.textContent);
    return Array.isArray(parsed) ? parsed : [];
  } catch (_unused) {
    return [];
  }
}

/**
 * @param {object | null} geoLocation GeoJS payload
 * @returns {string | null} ISO 3166-1 alpha-2 uppercase, or null
 */
function countryCodeFromGeo(geoLocation) {
  if (!geoLocation) {
    return null;
  }
  var code = String(geoLocation.country || '').trim().toUpperCase();
  return code || null;
}
function matchCountryRule(geoLocation) {
  var code = countryCodeFromGeo(geoLocation);
  if (!code) {
    return null;
  }
  for (var rule of rulesFromDocument()) {
    if (!rule) {
      continue;
    }
    var ruleCode = String(rule.country_code || '').trim().toUpperCase();
    if (ruleCode === code) {
      return rule;
    }
  }
  return null;
}
function dispatch(geoLocation, geoError) {
  var countryRule = null;
  var countryCode = !geoError && geoLocation ? countryCodeFromGeo(geoLocation) : null;
  if (!geoError && geoLocation && typeof window !== 'undefined') {
    countryRule = matchCountryRule(geoLocation);
    window.geo.matchedGeolocationRule = countryRule;
  } else if (typeof window !== 'undefined') {
    window.geo.matchedGeolocationRule = null;
  }

  /** @type {GeoLocationPayload} */
  var payload = {
    geo: geoLocation,
    error: geoError !== null && geoError !== void 0 ? geoError : null,
    countryCode,
    countryRule
  };
  callbacks.splice(0).forEach(cb => {
    try {
      cb(payload);
    } catch (e) {
      console.error(e);
    }
  });
}
function ensureFetch() {
  if (resolved) {
    return Promise.resolve();
  }
  if (inflight) {
    return inflight;
  }
  inflight = fetch(GEO_COUNTRY_URL, {
    credentials: 'omit',
    mode: 'cors'
  }).then(response => {
    if (!response.ok) {
      throw new Error("Geo request failed: ".concat(response.status));
    }
    return response.json();
  }).then(data => {
    location = data;
    error = null;
    resolved = true;
    dispatch(location, error);
  }).catch(err => {
    location = null;
    error = err;
    resolved = true;
    dispatch(location, error);
  }).finally(() => {
    inflight = null;
  });
  return inflight;
}

/**
 * @param {(payload: GeoLocationPayload) => void} callback
 */
function onLocation(callback) {
  if (typeof callback !== 'function') {
    return;
  }
  if (resolved) {
    queueMicrotask(() => {
      callbacks.push(callback);
      dispatch(location, error);
    });
    return;
  }
  callbacks.push(callback);
  ensureFetch();
}
if (typeof window !== 'undefined') {
  window.geo = window.geo || {};
  window.geo.onLocation = onLocation;
  window.geo.matchedGeolocationRule = null;
}